'use strict';

import size from 'lodash/size';
import customfn from './_functions';

const clp = (function () {
    // Functions

    return {
        version: '1.0.0',
        getStatusFromClp: function (iqs, repeaters, locks, tags, devices) {
            if (typeof iqs === "undefined")
                iqs = [];

            if (typeof repeaters === "undefined")
                repeaters = [];

            if (typeof locks === "undefined")
                locks = [];

            if (typeof tags === "undefined")
                tags = [];

            if (typeof devices === "undefined")
                devices = [];

            // Make CLP call when there are IQS found
            if (iqs.length > 0) {
                $(document).find('#restore-iq').hide();
                $.ajax({
                    url: '/helper/get_clp_status_for_iqs',
                    data: {'iqs': iqs},
                    dataType: "JSON",
                    success: function (data) {
                        if (size(data.iqs) > 0) {
                            $.each(data.iqs, function (index, el) {
                                if (
                                    el.id &&
                                    $('span[data-clp="status"][data-type="iq"][data-value="' + el.id + '"]').length > 0
                                ) {

                                    var id = parseInt(el.id);
                                    // Remove from page's iqs list
                                    var index = iqs.indexOf(id);
                                    if (index > -1) {
                                        iqs.splice(index, 1);
                                    }

                                    var $el = $('span[data-clp="status"][data-type="iq"][data-value="' + el.id + '"]');

                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;

                                    var status_icon = '<span class="fa fa-check text-success"></span>',
                                        signal_icon = '';
                                    if ($el.attr('data-check-online-state') && ($el.data('check-online-state') == "true" || $el.data('check-online-state') === true)) {
                                        if (!el.online || el.restore_required) {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();

                                            // Add new error message
                                            if (el.data_sync_state) {
                                                parentRow.after('<tr><td colspan="' + cols + '" class="error-row"><div class="form-group"><p class="invalid-feedback d-block">' + el.data_sync_state + '</p></div></td>')
                                            }

                                            // Set icon
                                            status_icon = '<span class="fa fa-remove text-danger"></span>';
                                        }
                                    }

                                    let your_action = $(document).find('#action-text');
                                    if (el.state === 'installation') {
                                        // replace the 'none' text in 'your action' column
                                        // in commissioning flow step 6/6 activate hardware
                                        if (your_action.length) {
                                            your_action.removeClass();
                                            your_action.addClass('text-danger');
                                            your_action.text("please use Nebula app to configure");
                                        } else {
                                            status_icon += '&nbsp;<span class="align-top text-danger">please use Nebula app to configure</span>';
                                        }
                                    } else {
                                        if (your_action.length) {
                                            your_action.removeClass();
                                            your_action.addClass('text-inactive');
                                            your_action.text("none");
                                        }
                                    }

                                    // If the restore is required
                                    // and the data attribute check-needs-restore
                                    // and there is a button to restore the iq
                                    if (el.restore_required &&
                                        $(document).find('#restore-iq').length &&
                                        ($el.attr('data-check-needs-restore') && ($el.data('check-needs-restore') == "true" || $el.data('check-needs-restore') === true))) {
                                        $(document).find('#restore-iq').show();
                                    }

                                    signal_icon = '';
                                    if (el.online) {
                                        if (Object.prototype.hasOwnProperty.call(el, 'signal_strength')) {
                                            signal_icon = customfn.getSignalStrengthIcon(el.signal_strength);
                                        } else {
                                            signal_icon = customfn.getSignalStrengthIcon('none');
                                        }
                                    }


                                    $el.after(status_icon + signal_icon);
                                    $el.parent().find('.spinner').hide();
                                $el.parent().find('.status-button').each(function() {
                                    customfn.resetButtonLoadingState(this);
                                });
                                    $el.hide();
                                }
                            });

                        }
                        if (iqs.length > 0 && data.not_found_error) {
                            customfn.placeErrorAfterItem(iqs, 'iq', data.not_found_error, true);
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.responseJSON) {
                            var json = jqXHR.responseJSON;
                            if (iqs.length > 0 && json.not_found_error) {
                                customfn.placeErrorAfterItem(iqs, 'iq', json.not_found_error, true);
                            }
                        }
                    }
                });
            }

            // Make CLP call when there are Repeaters found
            if (repeaters.length > 0) {
                $.ajax({
                    url: '/helper/get_clp_status_for_repeaters',
                    data: {'repeaters': repeaters},
                    dataType: "JSON",
                    success: function (data) {
                        if (size(data.repeaters) > 0) {
                            $.each(data.repeaters, function (index, el) {
                                if (
                                    el.id &&
                                    $('span[data-clp="status"][data-type="repeater"][data-value="' + el.id + '"]').length > 0
                                ) {
                                    var id = parseInt(el.id);
                                    // Remove from page's repeaters list
                                    var index = repeaters.indexOf(id);
                                    if (index > -1) {
                                        repeaters.splice(index, 1);
                                    }

                                    var $el = $('span[data-clp="status"][data-type="repeater"][data-value="' + el.id + '"]');

                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;

                                    var status_icon = '<span class="fa fa-check text-success"></span>';

                                    if ($el.attr('data-check-online-state') && ($el.data('check-online-state') == "true" || $el.data('check-online-state') === true)) {
                                        if (!el.online) {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();

                                            // Set icon
                                            status_icon = '<span class="fa fa-remove text-danger"></span>';
                                        }
                                    }

                                    if ($el.attr('data-check-attached-state')) {
                                        if (el.iq_link_state == "attached_pending" || el.iq_link_state == "detached" || el.iq_link_state == "detached_pending") {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();
                                            // Set icon
                                            status_icon = '<span class="fa fa-remove text-danger"></span>';

                                            if ($el.attr('data-show-activation-method')) {
                                                $el.closest('td').find('.activation_method').show();
                                            }
                                        } else {
                                            var prev = $el.closest('td').prev();
                                            if (prev.hasClass('activation_action')) {
                                                prev.html('<span class="text-inactive">' + data.none + '</span>');
                                            }

                                            if ($el.attr('data-show-activation-method')) {
                                                $el.closest('td').find('.activation_method').hide();
                                            }
                                        }
                                    }
                                    $el.after(status_icon);
                                    $el.parent().find('.spinner').hide();
                                $el.parent().find('.status-button').each(function() {
                                    customfn.resetButtonLoadingState(this);
                                });
                                    $el.hide();
                                }
                            });

                        }

                        if (repeaters.length > 0 && data.not_found_error) {
                            customfn.placeErrorAfterItem(repeaters, 'repeater', data.not_found_error);
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.responseJSON) {
                            var json = jqXHR.responseJSON;
                            if (repeaters.length > 0 && json.not_found_error) {
                                customfn.placeErrorAfterItem(repeaters, 'repeater', json.not_found_error);
                            }
                        }
                    }
                });
            }

            // Make CLP call when there are Locks found
            if (locks.length > 0) {

                //Split up lock array into chunks of 50 to prevent URL issues
                var locksplit = [], chunckSize = 50;
                while (locks.length > 0)
                    locksplit.push(locks.splice(0, chunckSize));

                $.each(locksplit, function (index, locks) {
                    $.ajax({
                        url: '/helper/get_clp_status_for_locks',
                        data: {'locks': locks},
                        dataType: "JSON",
                        success: function (data) {
                            if (size(data.locks) > 0) {
                                $.each(data.locks, function (index, el) {
                                    if (
                                        !el.id ||
                                            $('span[data-clp="status"][data-type="lock"][data-value="' + el.id + '"]').length === 0
                                    ) {
                                        return;
                                    }

                                    var id = parseInt(el.id);
                                    // Remove from page's locks list
                                    var index = locks.indexOf(id);
                                    if (index > -1) {
                                        locks.splice(index, 1);
                                    }

                                    var $el = $('span[data-clp="status"][data-type="lock"][data-value="' + el.id + '"]');

                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;

                                    var status_icon = '<span class="fa fa-check text-success"></span>';

                                    if ($el.attr('data-check-online-state') && ($el.data('check-online-state') == "true" || $el.data('check-online-state') === true)) {
                                        if (!el.online) {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();
                                            // Set icon
                                            status_icon = '<span class="fa fa-remove text-danger"></span>';
                                        }
                                    }
                                    if ($el.attr('data-check-attached-state')) {
                                        if (el.iq_link_state == "attached_pending" || el.iq_link_state == "detached" || el.iq_link_state == "detached_pending") {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();
                                            // Set icon
                                            status_icon = '<span class="fa fa-remove text-danger"></span>';

                                            if ($el.attr('data-show-activation-method')) {
                                                $el.closest('td').find('.activation_method').show();
                                            }
                                        } else {
                                            var prev = $el.closest('td').prev();
                                            if (prev.hasClass('activation_action')) {
                                                prev.html('<span class="text-inactive">' + data.none + '</span>');
                                            }

                                            if ($el.attr('data-show-activation-method')) {
                                                $el.closest('td').find('.activation_method').hide();
                                            }

                                        }
                                    }

                                    if (el.lock_type !== 'wall_reader' && el.lock_type !== 'wall_reader_pin') {
                                        if (el.battery_level && ((el.iq_link_state == "attached" && el.battery_level == "none") || el.battery_level == "low")) {
                                            status_icon += '<span class="low-battery"></span>';
                                        }
                                    }

                                    if (el.supports_signal_strength) {
                                        status_icon += '<a class="ms-2 js-refresh-signal-strength" data-lock-id="' + el.id + '" href="#" title="Refresh signal strength">' +
                                            '<span class="fa fa-arrows-rotate text-secondary"></span>' +
                                            '</a>';

                                        if (el.signal_strength_text !== null) {
                                            status_icon += customfn.getSignalStrengthIcon(el.signal_strength_text);
                                        } else {
                                            status_icon += '<div></div>';
                                        }
                                    }

                                    $el.after(status_icon);
                                    $el.parent().find('.spinner').hide();
                                    $el.parent().find('.status-button').each(function () {
                                        customfn.resetButtonLoadingState(this);
                                    });
                                    $el.hide();

                                });

                            }

                            if (locks.length > 0 && data.not_found_error) {
                                customfn.placeErrorAfterItem(locks, 'lock', data.not_found_error);
                            }
                        },
                        error: function (jqXHR) {
                            if (jqXHR.responseJSON) {
                                var json = jqXHR.responseJSON;
                                if (locks.length > 0 && json.not_found_error) {
                                    customfn.placeErrorAfterItem(locks, 'lock', json.not_found_error);
                                }
                            }
                        }
                    });
                });
            }

            // Make CLP call when there are Tags found
            if (tags.length > 0) {
                $.ajax({
                    url: '/helper/get_clp_status_for_tags',
                    data: {'tags': tags},
                    dataType: "JSON",
                    success: function (data) {

                        if (size(data.tags) > 0) {
                            $.each(data.tags, function (index, el) {
                                if (
                                    el.id &&
                                    $('span[data-clp="status"][data-type="tag"][data-value="' + el.id + '"]').length > 0
                                ) {

                                    var id = parseInt(el.id);
                                    // Remove from page's tags list
                                    var index = tags.indexOf(id);
                                    if (index > -1) {
                                        tags.splice(index, 1);
                                    }

                                    var $el = $('span[data-clp="status"][data-type="tag"][data-value="' + el.id + '"]');

                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;


                                    var status_icon = '<span class="text-' + el.status + ' tag-status">' + el.status_text + '</span>';


                                    $el.after(status_icon);
                                    $el.parent().find('.spinner').hide();
                                $el.parent().find('.status-button').each(function() {
                                    customfn.resetButtonLoadingState(this);
                                });
                                    $el.hide();
                                }
                            });

                        }

                        if (tags.length > 0 && data.not_found_error) {
                            customfn.placeErrorAfterItem(tags, 'tag', data.not_found_error);
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.responseJSON) {
                            var json = jqXHR.responseJSON;
                            if (tags.length > 0 && json.not_found_error) {
                                customfn.placeErrorAfterItem(tags, 'tag', json.not_found_error);
                            }
                        }
                    }
                });
            }

            // Make CLP call when there are Tags found
            if (devices.length > 0) {
                $.ajax({
                    url: '/helper/get_clp_status_for_devices',
                    data: {'devices': devices},
                    dataType: "JSON",
                    success: function (data) {

                        if (size(data.devices) > 0) {
                            $.each(data.devices, function (index, el) {
                                if (
                                    el.id &&
                                    $('span[data-clp="status"][data-type="device"][data-value="' + el.id + '"]').length > 0
                                ) {

                                    var id = parseInt(el.id);
                                    // Remove from page's tags list
                                    var index = devices.indexOf(id);
                                    if (index > -1) {
                                        devices.splice(index, 1);
                                    }

                                    var $el = $('span[data-clp="status"][data-type="device"][data-value="' + el.id + '"]');

                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;


                                    var status_icon = '<span class="text-' + el.status + ' device-status">' + el.status_text + '</span>';


                                    $el.after(status_icon);
                                    $el.parent().find('.spinner').hide();
                                $el.parent().find('.status-button').each(function() {
                                    customfn.resetButtonLoadingState(this);
                                });
                                    $el.hide();
                                }
                            });

                        }

                        if (devices.length > 0 && data.not_found_error) {
                            customfn.placeErrorAfterItem(devices, 'device', data.not_found_error);
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.responseJSON) {
                            var json = jqXHR.responseJSON;
                            if (devices.length > 0 && json.not_found_error) {
                                customfn.placeErrorAfterItem(devices, 'device', json.not_found_error);
                            }
                        }
                    }
                });
            }
        },

        getLockStatusFromClp: function(locks, jumbo)
        {
            if (typeof locks === "undefined")
                locks = [];

            // Make CLP call when there are Locks found
            if (locks.length > 0) {

                //Split up lock array into chunks of 50 to prevent URL issues
                var locksplit = [], chunckSize = 50;
                while (locks.length > 0)
                    locksplit.push(locks.splice(0, chunckSize));

                $.each(locksplit, function (index, locks) {
                    $.ajax({
                        url: '/helper/get_clp_status_for_locks',
                        data: {'locks': locks},
                        dataType: "JSON",
                        success: function (data) {
                            var locked = true;
                            var low_battery = false;
                            if (size(data.locks) > 0) {
                                $.each(data.locks, function (index, lock) {
                                    if (
                                        lock.id &&
                                        $('span[data-clp="locked"][data-type="lock"][data-value="' + lock.id + '"]').length > 0
                                    ) {

                                        var id = parseInt(lock.id);
                                        // Remove from page's locks list
                                        var index = locks.indexOf(id);
                                        if (index > -1) {
                                            locks.splice(index, 1);
                                        }
                                        var $el = $('span[data-clp="locked"][data-type="lock"][data-value="' + lock.id + '"]');


                                        // There is a single lock online, this has no state
                                        // Lock should be marked "unactivated"
                                        if (!lock.online) {
                                            locked = "offline";
                                            if (lock.iq_link_state == "attached_pending" || lock.iq_link_state == "detached" || lock.iq_link_state == "detached_pending") {
                                                locked = 'unknown';
                                            }
                                            return false; // = break out of foreach
                                        } else {
                                            // If any of the locks are not locked, the inventory is probably open
                                            if (lock.locked_state != "locked") {
                                                locked = false;
                                            }

                                            if (['wall_reader', 'wall_reader_pin'].includes(lock.lock_type)) {
                                                lock.battery_level = 'wall_reader';
                                            }

                                            if (lock.battery_level == "low" || lock.battery_level == "none") {
                                                low_battery = true;
                                            }
                                        }
                                    }
                                });
                            }

                            // There are locks that could not be found in CLP
                            // Room is offline
                            if (locks.length > 0) {
                                locked = "offline"
                            }

                            if (locked == "unknown") {
                                var status_icon = '<span class="icon-space-unknown"></span>';
                                var state = 'unknown';
                            } else if (locked == "offline") {
                                var status_icon = '<span class="icon-space-offline"></span>';
                                var state = 'offline';
                            } else if (locked) {
                                var status_icon = '<span class="icon-space-locked"></span>';
                                var state = 'locked';
                            } else {
                                var status_icon = '<span class="icon-space-unlocked"></span>';
                                var state = 'unlocked';
                            }

                            jumbo.find('div.icon').html(status_icon);
                        jumbo.find('span.state-' + state).removeClass('d-none');
                        jumbo.find('div.main-data h4.state-' + state).removeClass('d-none');
                        jumbo.find('div.main-data h5.state-' + state).removeClass('d-none');
                            jumbo.addClass('state-' + state);

                            if ((state == "locked" || state == "unlocked") && low_battery) {
                            jumbo.find('div.main-data h5.state-low-battery').removeClass('d-none');
                            }


                        },
                        error: function (jqXHR) {
                            var status_icon = '<span class="icon-user-inactive text-inactive"></span>';
                            var state = 'unknown';
                            jumbo.find('div.icon').html(status_icon);
                        jumbo.find('div.main-data h4.state-' + state).removeClass('d-none');
                        }
                    });
                });
            }
        },

        getInventoryStatus: function(inventories) {
            if (typeof inventories === "undefined")
                inventories = [];

            // Make CLP call when there are Locks found
            if (inventories.length > 0) {
                $.ajax({
                    url: '/helper/get_clp_status_for_inventories',
                    data: {'inventories': inventories},
                    dataType: "JSON",
                    success: function (data) {
                        var locked = true;
                        if (size(data.inventories) > 0) {
                            $.each(data.inventories, function (index, inventory) {
                                if (
                                    inventory.id &&
                                    $('span[data-clp="locked"][data-type="inventory"][data-value="' + inventory.id + '"]').length > 0
                                ) {

                                    var id = parseInt(inventory.id);

                                    var index = inventories.indexOf(id);
                                    if (index > -1) {
                                        inventories.splice(index, 1);
                                    }
                                    var $el = $('span[data-clp="locked"][data-type="inventory"][data-value="' + inventory.id + '"]');

                                $el.closest('.space-status').find('.inventory-state').addClass('d-none');
                                    var parentRow = $el.closest('tr');
                                    var cols = parentRow.closest('table').find('thead th').length;

                                    if ($el.attr('data-check-online-state') && ($el.data('check-online-state') == "true" || $el.data('check-online-state') === true)) {
                                        if (!inventory.supports_easy_office_mode) {
                                            $el.closest('.space-status').find('.inventory-state.state-locked').removeClass('d-none');
                                        } else if (!inventory.online) {
                                            // Remove error message if any
                                            parentRow.next().find('td.error-row').parent().remove();
                                            $el.closest('.space-status').find('.inventory-state.state-offline').removeClass('d-none');
                                        } else {
                                            if (inventory.locked_state == 'locked') {
                                                $el.closest('.space-status').find('.inventory-state.state-locked').removeClass('d-none');
                                            } else {
                                                $el.closest('.space-status').find('.inventory-state.state-unlocked').removeClass('d-none');
                                            }

                                        }
                                    }

                                    $el.parent().find('.spinner').hide();
                                $el.parent().find('.status-button').each(function() {
                                    customfn.resetButtonLoadingState(this);
                                });
                                    $el.hide();
                                }
                            });
                        }
                    },
                    error: function (jqXHR) {
                        if (jqXHR.responseJSON) {
                            var json = jqXHR.responseJSON;
                            if (inventories.length > 0 && json.not_found_error) {
                                customfn.placeErrorAfterItem(inventories, 'inventory', json.not_found_error);
                            }
                        }
                    }
                });
            }
        },

        // refresh the hardware status
        refreshHardware: function($table) {
            var clp = this;
            var iqs = [],
                repeaters = [],
                locks = [],
                tags = [],
                devices = [];

            var parent = $table;

        // Get list of IQS to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="iq"]').each(function (index, el) {
            iqs.push($(el).data('value'));

                $(el).closest('tr').next().find('td.error-row').parent().remove();
                $(el).parent().find('.fa, .wifi-symbol').remove();
                $(el).parent().find('.fa, .low-battery').remove();
                $(el).parent().find('.spinner').show();
            });

        // Get list of Repeaters to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="repeater"]').each(function (index, el) {
            repeaters.push($(el).data('value'));

                $(el).closest('tr').next().find('td.error-row').parent().remove();
                $(el).parent().find('.fa, .wifi-symbol').remove();
                $(el).parent().find('.fa, .low-battery').remove();
                $(el).parent().find('.spinner').show();
            });

        // Get list of Locks to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="lock"]').each(function (index, el) {
            if (locks.indexOf($(el).data('value')) === -1) {
                locks.push($(el).data('value'));
            }
            $(el).closest('tr').next().find('td.error-row').parent().remove();
            $(el).parent().find('.fa, .wifi-symbol').remove();
            $(el).parent().find('.fa, .low-battery').remove();
            $(el).parent().find('.spinner').show();
        });

        // Get list of tags to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="tag"]').each(function (index, el) {
            if (tags.indexOf($(el).data('value')) === -1) {
                tags.push($(el).data('value'));
            }

                $(el).closest('tr').next().find('td.error-row').parent().remove();
                $(el).parent().find('.tag-status').remove();
                $(el).parent().find('.spinner').show();
            });

        // Get list of devices to fetch data from all at once
        parent.find('span[data-clp="status"][data-type="device"]').each(function (index, el) {
            if (devices.indexOf($(el).data('value')) === -1) {
                devices.push($(el).data('value'));
            }

                $(el).closest('tr').next().find('td.error-row').parent().remove();
                $(el).parent().find('.device-status').remove();
                $(el).parent().find('.spinner').show();
            });

            clp.getStatusFromClp(iqs, repeaters, locks, tags, devices);

        },

        getLocksStatuses: function() {
            var clp = this;
            $('.space-status').each(function (index, el) {
                var locks = [];
                // Get list of Locks to fetch data from all at once
                $(document).find('span[data-clp="locked"][data-type="lock"]').each(function (index, el) {
                    locks.push($(el).data('value'));
                    $(el).parent().find('.spinner').show();
                });

                clp.getLockStatusFromClp(locks, $(document));
            });
        },

        getInventoryStatuses: function() {
            var clp = this;
            var inventories = [];
            $(document).find('span[data-clp="locked"][data-type="inventory"]').each(function (index, el) {
                inventories.push($(el).data('value'));
            });
            clp.getInventoryStatus(inventories);
        }
    }
})();

export default clp;
